/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BillingRule {
    __type: string;

    protected setDiscriminator(type: string) {
        this.__type = type;
    }

    getFixupPrototypeFunction() { return BillingRule.fixupPrototype; }

    static newInstance(model: Partial<BillingRule>): BillingRule {
        let obj = Object.assign(new BillingRule(), model);
        BillingRule.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BillingRule>): BillingRule {
        if (!model) return null;
        return BillingRule.newInstance(<BillingRule> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BillingRule) {
        if (!obj) return;

        models.BillingRule.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BillingRule): boolean {
        switch (obj.__type)
        {
            case "BillingRuleAllocation":
                Object.setPrototypeOf(obj, models.BillingRuleAllocation.prototype);
                break;
            case "BillingRuleAllocationEqual":
                Object.setPrototypeOf(obj, models.BillingRuleAllocationEqual.prototype);
                break;
            case "BillingRuleAllocationGenericTargets":
                Object.setPrototypeOf(obj, models.BillingRuleAllocationGenericTargets.prototype);
                break;
            case "BillingRuleAllocationPercentage":
                Object.setPrototypeOf(obj, models.BillingRuleAllocationPercentage.prototype);
                break;
            case "BillingRuleAllocationProportionalServiceCategory":
                Object.setPrototypeOf(obj, models.BillingRuleAllocationProportionalServiceCategory.prototype);
                break;
            case "BillingRuleAllocationProportionalServiceCategoryCloudAndPlatform":
                Object.setPrototypeOf(obj, models.BillingRuleAllocationProportionalServiceCategoryCloudAndPlatform.prototype);
                break;
            case "BillingRuleAllocationProportionalServiceCategoryPlatform":
                Object.setPrototypeOf(obj, models.BillingRuleAllocationProportionalServiceCategoryPlatform.prototype);
                break;
            case "BillingRuleAllocationProportionalSpend":
                Object.setPrototypeOf(obj, models.BillingRuleAllocationProportionalSpend.prototype);
                break;
            case "BillingRuleAllocationProportionalSpendCloudAndPlatform":
                Object.setPrototypeOf(obj, models.BillingRuleAllocationProportionalSpendCloudAndPlatform.prototype);
                break;
            case "BillingRuleAllocationProportionalSpendPlatform":
                Object.setPrototypeOf(obj, models.BillingRuleAllocationProportionalSpendPlatform.prototype);
                break;
            case "BillingRuleAllocationProportionalUsage":
                Object.setPrototypeOf(obj, models.BillingRuleAllocationProportionalUsage.prototype);
                break;
            case "BillingRuleCalculate":
                Object.setPrototypeOf(obj, models.BillingRuleCalculate.prototype);
                break;
            case "BillingRuleCommitmentUnshare":
                Object.setPrototypeOf(obj, models.BillingRuleCommitmentUnshare.prototype);
                break;
            case "BillingRuleCreateLineItem":
                Object.setPrototypeOf(obj, models.BillingRuleCreateLineItem.prototype);
                break;
            case "BillingRuleCreateLineItemBase":
                Object.setPrototypeOf(obj, models.BillingRuleCreateLineItemBase.prototype);
                break;
            case "BillingRuleCreateLineItemFromPercentage":
                Object.setPrototypeOf(obj, models.BillingRuleCreateLineItemFromPercentage.prototype);
                break;
            case "BillingRuleCreateLineItemFromTiered":
                Object.setPrototypeOf(obj, models.BillingRuleCreateLineItemFromTiered.prototype);
                break;
            case "BillingRuleFixedCustomRate":
                Object.setPrototypeOf(obj, models.BillingRuleFixedCustomRate.prototype);
                break;
            case "BillingRuleFixedTiered":
                Object.setPrototypeOf(obj, models.BillingRuleFixedTiered.prototype);
                break;
            case "BillingRuleGroup":
                Object.setPrototypeOf(obj, models.BillingRuleGroup.prototype);
                break;
            case "BillingRuleMargin":
                Object.setPrototypeOf(obj, models.BillingRuleMargin.prototype);
                break;
            case "BillingRulePercentageCalculate":
                Object.setPrototypeOf(obj, models.BillingRulePercentageCalculate.prototype);
                break;
            case "BillingRulePublish":
                Object.setPrototypeOf(obj, models.BillingRulePublish.prototype);
                break;
            case "BillingRuleRoot":
                Object.setPrototypeOf(obj, models.BillingRuleRoot.prototype);
                break;
            case "BillingRuleStop":
                Object.setPrototypeOf(obj, models.BillingRuleStop.prototype);
                break;
            case "BillingRuleStopGroup":
                Object.setPrototypeOf(obj, models.BillingRuleStopGroup.prototype);
                break;
        }
        return true; // Tell the caller this is a polymorphic type, it should not overwrite the prototype.
    }

    static getTypeHierarchy(): (typeof BillingRule)[] {
        return [
            models.BillingRuleAllocation,
            models.BillingRuleAllocationEqual,
            models.BillingRuleAllocationGenericTargets,
            models.BillingRuleAllocationPercentage,
            models.BillingRuleAllocationProportionalServiceCategory,
            models.BillingRuleAllocationProportionalServiceCategoryCloudAndPlatform,
            models.BillingRuleAllocationProportionalServiceCategoryPlatform,
            models.BillingRuleAllocationProportionalSpend,
            models.BillingRuleAllocationProportionalSpendCloudAndPlatform,
            models.BillingRuleAllocationProportionalSpendPlatform,
            models.BillingRuleAllocationProportionalUsage,
            models.BillingRuleCalculate,
            models.BillingRuleCommitmentUnshare,
            models.BillingRuleCreateLineItem,
            models.BillingRuleCreateLineItemBase,
            models.BillingRuleCreateLineItemFromPercentage,
            models.BillingRuleCreateLineItemFromTiered,
            models.BillingRuleFixedCustomRate,
            models.BillingRuleFixedTiered,
            models.BillingRuleGroup,
            models.BillingRuleMargin,
            models.BillingRulePercentageCalculate,
            models.BillingRulePublish,
            models.BillingRuleRoot,
            models.BillingRuleStop,
            models.BillingRuleStopGroup,
        ];
    }

    fixupFields() {
        if (typeof this.start_date === "string") {
            this.start_date = new Date(<string><any>this.start_date);
        }
        if (typeof this.end_date === "string") {
            this.end_date = new Date(<string><any>this.end_date);
        }
        if (this.scope) {
            models.QueryOperator.fixupPrototype(this.scope);
        }
    }

    /**
     * Name of the billing rule
     */
    name: string;

    /**
     * Description of the billing rule
     */
    description: string;

    /**
     * True if the billing plan is active
     */
    is_active: boolean;

    /**
     * Filter to select the line items this rule applies to.
     */
    scope: models.QueryOperator;

    /**
     * Start date of the billing rule
     */
    start_date: Date;

    /**
     * End date of the billing rule
     */
    end_date: Date;

    /**
     * Note for the billing rule
     */
    note: string;

    /**
     * List of attachment IDs
     */
    attachment_ids: Array<string>;

}
